export default "{\n    \"todayLabel\": \"Today\"\n}\n"